import React, { useState, useEffect, useContext } from 'react'
import UsersScheduler from './UsersScheduler'
import { appContext } from '../../../../../../App'
import { updateClientSchedules } from '../../NPOSAccountFunctions'

export const usersSchedulerContext = React.createContext()

function useUsersSchedulerController() {
  const app = useContext(appContext)
  const [schedules, setSchedules] = useState(app.client.schedules || [])
  const [update, setUpdate] = useState(null)

  const initSchedule = {
    title: '',
    time: {
      from: {
        hour: '8',
        minute: '00',
        state: 'AM'
      },
      to: {
        hour: '5',
        minute: '00',
        state: 'PM'
      },
      all_the_time: false
    },
    days: {
      sunday: false,
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: false
    },
    users_list: []
  }
  const [schedule, setSchedule] = useState(initSchedule)

  const updateSchedules = (sched) => {
    // It's an update
    if (sched.id) {
      setSchedules([...schedules.filter(s => s.id !== sched.id), sched])
      setUpdate(`Updated schedule ${sched.id} ${sched.title}`)
    } else {
      //sched.id = new Date(new Date().toLocaleString('en-Us', app.client.time_zone)).getTime()
      sched.id = new Date(new Date().toLocaleString('en-Us', app.client.company_address.time_zone)).getTime()
      setSchedules([...schedules, sched])
      setUpdate(`Added new schedule ${sched.id} ${sched.title}`)
    }
  }

  const deleteSchedule = (schedule_id) => {
    setSchedules(schedules.filter(s => s.id !== schedule_id))
    const sched = schedules.find(s => s.id === schedule_id)
    setUpdate(`Deleted schedule ${sched.id} ${sched.title}`)
  }
  
  useEffect(() => {
    // Probably fire-up auto-save here
    const updateSchedules = async () => {
      app.client.schedules = schedules
      app.client.schedules_update = update
      await updateClientSchedules(app, app.client)
      setUpdate(null)
    }

    if (update) updateSchedules()
    
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [update])
  
  return ({
    schedule: [schedule, setSchedule, initSchedule],
    schedules: [schedules, updateSchedules, deleteSchedule],
    update: [update, setUpdate]
  })
}

function UsersSchedulerController(props) {
  const usersSchedulerController = useUsersSchedulerController(props)
  return (
    <React.Fragment>
      <usersSchedulerContext.Provider value={usersSchedulerController}>
        <UsersScheduler />
      </usersSchedulerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(UsersSchedulerController)